import { jsx as _jsx } from "react/jsx-runtime";
import { useLocalizeMessage } from 'libs.nucleus';
import { FileDropZone } from '../../components/file_drop_zone';
import { StackOfDocumentsSolidIcon } from '../../icons';
const MAX_FILES = 15;
const ACCEPTED_TYPES = [
    '.pdf',
    '.docx',
    '.xls',
    '.xlsx',
    '.csv',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
];
export const ConsentUploadZone = ({ onFileAdd }) => {
    const translate = useLocalizeMessage();
    const handleUpload = async (files) => {
        onFileAdd(files);
    };
    return (_jsx("div", { className: 'nucleus-mb-6', children: _jsx(FileDropZone, { onUpload: handleUpload, title: translate('Add files here or click to upload consent templates'), description: translate('Once a source map is uploaded the AI agent will automatically process signature fields, metadata, and site assignments.'), acceptedFileTypes: ACCEPTED_TYPES.join(','), acceptedExtensions: ['PDF', 'DOCX', 'XLS', 'XLSX', 'CSV'], maxFileSize: 25, maxFiles: MAX_FILES, icon: _jsx("span", { style: { color: '#D4C9FF' }, children: _jsx(StackOfDocumentsSolidIcon, { size: 60 }) }) }) }));
};
